import { render, staticRenderFns } from "./switchCommuication.vue?vue&type=template&id=6ec3c86a&scoped=true"
import script from "./switchCommuication.vue?vue&type=script&lang=js"
export * from "./switchCommuication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3c86a",
  null
  
)

export default component.exports